import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    component: () => import('@/layouts/DashboardLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/dashboard' },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/DashboardView.vue'),
      },
      {
        path: 'devices',
        name: 'devices',
        component: () => import('@/views/DevicesView.vue'),
      },
      {
        // _298 · 全量设备管理（独立于激活码列表 · 涵盖试用模式）
        path: 'devices-all',
        name: 'devices-all',
        component: () => import('@/views/DeviceManageView.vue'),
      },
      {
        path: 'purchase',
        name: 'purchase',
        component: () => import('@/views/PurchaseView.vue'),
      },
      {
        path: 'admin/codes',
        name: 'admin-codes',
        component: () => import('@/views/AdminCodesView.vue'),
      },
      {
        path: 'admin/synapse',
        name: 'admin-synapse',
        component: () => import('@/views/AdminSynapseView.vue'),
      },
      {
        path: 'admin/updates',
        name: 'admin-updates',
        component: () => import('@/views/AdminUpdatesView.vue'),
      },
      {
        path: 'remote-destruct',
        name: 'remote-destruct',
        component: () => import('@/views/RemoteDestructView.vue'),
      },
      {
        // _426 · 审计日志管理（筛选 + 批量软删 + 导出）
        path: 'audit-logs',
        name: 'audit-logs',
        component: () => import('@/views/AuditLogsView.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard',
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 简易导航守卫：未登录跳 /login
router.beforeEach((to) => {
  const auth = useAuthStore()
  if (to.meta.requiresAuth !== false && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'dashboard' }
  }
  return true
})
